import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgCardTypeVimeo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M31.886 25.508c0 3.522-2.855 6.377-6.377 6.377H6.377C2.857 31.885 0 29.03 0 25.508V6.378C0 2.854 2.857 0 6.377 0H25.51c3.522 0 6.377 2.855 6.377 6.377v19.131",
			fill: "#0FB7FF"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M25.998 10.58c.175-.982.17-1.992-.436-2.755-.846-1.07-2.646-1.11-3.88-.921-1.003.153-4.397 1.651-5.552 5.236 2.046-.156 3.118.148 2.921 2.4-.082.943-.558 1.976-1.09 2.966-.614 1.141-1.765 3.382-3.274 1.767-1.36-1.454-1.257-4.235-1.568-6.086-.173-1.04-.356-2.334-.697-3.402-.293-.92-.966-2.027-1.788-2.267-.884-.26-1.976.146-2.618.523-2.042 1.2-3.598 2.908-5.365 4.317v.132c.35.335.444.884.96.959 1.216.179 2.375-1.134 3.184.232.492.834.645 1.749.96 2.648.42 1.198.746 2.503 1.09 3.88.583 2.334 1.299 5.82 3.316 6.675 1.029.437 2.575-.148 3.358-.612 2.122-1.255 3.775-3.075 5.19-4.927 3.234-4.382 5.019-9.347 5.289-10.765",
			fill: "#FFFFFE"
		})]
	})
});
export default SvgKgCardTypeVimeo;
